// @flow
import xws from 'api/xws/';
import qs from 'query-string';
import type { AxiosPromise } from 'axios';
import type { XWSResponse } from 'api/clients/xws';

// Constants
import { getService } from 'constants/ajax';

type RequestData = {|
  tokenId: string,
  webkey: string,
  languageCode: string,
  locale: string,
  countryCode: string,
  newPassword: string,
  password: string
|};

export default function changePasswordWs({
  tokenId,
  webkey,
  languageCode,
  locale,
  countryCode,
  newPassword,
  password
}: RequestData): AxiosPromise<RequestData, XWSResponse> {
  const changePasswordService = getService('changePassword');
  return xws(changePasswordService).post(
    changePasswordService.getPath(),
    qs.stringify({
      tokenId,
      webkey,
      languageCode,
      locale,
      countryCode,
      newPassword,
      password
    })
  );
}



// WEBPACK FOOTER //
// ./src/api/xws/profile/changePasswordWs.js